export type ShowUnsavedChangesWarning = (
  resolve: (navigate?: boolean) => void
) => void;

export const confirmNavigation = (
  hasUnsavedChanges: boolean,
  showUnsavedChangesWarning: ShowUnsavedChangesWarning
): boolean | Promise<boolean> => {
  if (!hasUnsavedChanges) {
    return true;
  }

  return new Promise(resolve => {
    showUnsavedChangesWarning(navigate => resolve(navigate !== false));
  });
};
